import ApiService from "@/common/services/http/api.service";

const UsuarioService = {
  /**
   * Buscar os departamentos por clientes
   * @param clienteID id do cliente
   * @returns {*}
   */
  async getUsuarios(clienteID) {
    const { data: result } = await ApiService.get(
      "usuario/getbyclienteid",
      clienteID
    );

    return result;
  },
};

export default UsuarioService;
